import React from "react";
import Header8 from "./../Common/Header8";
import Footer from "./../Common/Footer";
import Banner from "./../Elements/Banner";
import About1 from "./../Elements/About1";
import About3 from "./../Elements/About3";
import WhatWeDo6 from "./../Elements/WhatWeDo6";
import ClientsLogo1 from "./../Elements/ClientsLogo1";
import Testimonials1 from "../Elements/Testimonials1";

var bnrimg = require("../../images/banner/banner.jpg");

class About extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", function () {
          resolve();
        });
        script.addEventListener("error", function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }

    loadScript("./assets/js/custom.js");
  }
  render() {
    return (
      <>
        <Header8 />
        <div className="page-content">
          <Banner
            parent="A Propos"
            title="Qui sommes-nous"
            pagename="Qui sommes-nous"
            bgimage={bnrimg}
          />
          <About1 />
          <Testimonials1 />
          {/* <About3 bgcolor="bg-gray" /> */}
          <ClientsLogo1 />
        </div>

        <Footer />
      </>
    );
  }
}

export default About;
